/*
|--------------------------------------------------------------------------
|
| 这些组件暴露给使用方
|
|--------------------------------------------------------------------------
*/
import App from './App.vue';
import HelloWorld from './HelloWorld.vue';
import Configuration from './Configuration.vue';
export default {
  App,
  HelloWorld,
  Configuration
};
